export default __webpack_public_path__ + "static/media/activity.09c1dd70.svg";